export default __webpack_public_path__ + "static/media/youtube.f86c04ad.svg";